import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const Root = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "24px",
  width: "68px",
  padding: theme.spacing(0.5, 0.5, 0.5, 1),
  borderRadius: "2px",
  border: `1px solid ${theme.palette.primary[800]}`,
  boxSizing: "border-box",
  color: theme.palette.primary[800],
  cursor: "pointer"
}));
const RoomName = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "36px",
  color: theme.palette.primary[800]
}));
const OptionsContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(1, 0)
}));
const StyledKeyboardArrowDown = styled(KeyboardArrowDown)(({ theme }) => ({
  width: "16px",
  height: "16px",
  color: theme.palette.primary[800]
}));
const StyledKeyboardArrowUp = styled(KeyboardArrowUp)(({ theme }) => ({
  width: "16px",
  height: "16px",
  color: theme.palette.primary[800]
}));
export {
  OptionsContainer,
  RoomName,
  Root,
  StyledKeyboardArrowDown,
  StyledKeyboardArrowUp
};
